import React, { useEffect, useState } from "react";
import { useAppSelector } from "@/redux-config/hooks";
import { selectUser } from "@/redux-config/entities/user";
import { Helmet } from "react-helmet";
import { CustomBreadCrumb } from "@/components/customBreadCrumb";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { CustomInput, Loading } from "@/components";
import { AdminApi } from "@/api";
import { useNavigate, useParams } from "react-router-dom";

export const AdminEdit: React.FC<{}> = () => {
  const user = useAppSelector(selectUser);
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const crumbs = [
    { name: t("Dashboard"), href: "/" },
    { name: t("Admin"), href: "#" },
    { name: t("New"), href: "#" }
  ];

  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");

  const [loading, setLoading] = useState<boolean>(false);

  const handleGetData = () => {
    setLoading(true);
    AdminApi.GetAdminById(user, id + "").then((data) => {
      setFirstName(data.data.first_name ? data.data.first_name : "");
      setLastName(data.data.last_name ? data.data.last_name : "");
      setLoading(false);
    }).catch((err) => {
      setLoading(false);
    });
  };

  useEffect(() => {
    handleGetData();
  }, [id]);

  const handleCreateAdmin = () => {
    setLoading(true);
    AdminApi.EditAdmin(user, id + "", firstName, lastName).then((data) => {
      navigate(`/admin/info/${data.data.id}`);
      setLoading(false);
    }).catch((err) => {
      setLoading(false);
    });
  };

  return (
    <>
      <Helmet>
        <title>MahdiBookShop | User List</title>
        <meta name="description" content="Basic example" />
      </Helmet>
      <div className="d-flex flex-column">
        <CustomBreadCrumb breadCrumbList={crumbs} />
        {loading ?
          <Loading />
          :
          <div className={"d-flex flex-row flex-wrap"}>
            <div className={"col-12 col-md-6 col-lg-4 p-2"}>
              <div
                className={
                  "d-flex flex-column bg-custom-white p-3 rounded-3  gap-2 h-100"
                }
              >
                <h5>{t("BasicInfo")}</h5>
                <label className={"d-flex flex-column"}>
                  <small>{t("FirstName")}</small>
                  <CustomInput
                    name={"FirstName"}
                    type={"text_number"}
                    className={`custom-input ${
                      firstName.length == 0
                        ? "border-reg"
                        : firstName.length > 2
                          ? "border-success"
                          : "border-error"
                    }`}
                    value={firstName}
                    onChange={setFirstName}
                  />
                </label>
                <label className={"d-flex flex-column"}>
                  <small>{t("LastName")}</small>
                  <CustomInput
                    name={"LastName"}
                    type={"text_number"}
                    className={`custom-input ${
                      lastName.length == 0
                        ? "border-reg"
                        : lastName.length > 2
                          ? "border-success"
                          : "border-error"
                    }`}
                    value={lastName}
                    onChange={setLastName}
                  />
                </label>

                <div>
                  <button
                    className={"btn prm-btn rounded-5 px-4 mt-3"}
                    disabled={
                      !(
                        firstName.length > 2 &&
                        lastName.length > 2
                      )
                    }
                    onClick={() => {
                      handleCreateAdmin();
                    }}
                  >
                    {t("submit")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </>
  );
};
